import axios from 'axios'

const HTTP = axios.create({
  baseURL: 'https://portal.skymaps.cz:9998'
  // baseURL: 'http://localhost:9999'
})

export { HTTP }



// WEBPACK FOOTER //
// ./src/common/http.js